import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-100">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-abyss z-0" data-id="element-101">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-mystic-900/20 via-abyss to-abyss opacity-50" data-id="element-102" />
        <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-abyss to-transparent opacity-80" data-id="element-103" />
        <div className="absolute bottom-0 left-0 right-0 h-64 bg-gradient-to-t from-abyss to-transparent" data-id="element-104" />

        {/* Animated Fog/Mist effect using CSS/SVG could go here, keeping it simple with gradients for now */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-mystic-600/10 rounded-full blur-[128px] animate-pulse-slow" data-id="element-105" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-purple-900/10 rounded-full blur-[96px] animate-pulse-slow delay-1000" data-id="element-106" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-108">
          <span className="inline-block py-1 px-3 rounded-full bg-white/5 border border-white/10 text-mystic-400 text-xs font-medium tracking-[0.2em] uppercase mb-6 backdrop-blur-sm" data-id="element-109">
            Est. 2026 • Limassol, Cyprus
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-110">
          Where Shadows <br data-id="element-111" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-mystic-400 to-purple-600 text-glow" data-id="element-112">
            Become Stories
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-113">
          Ombreludique is the premier publishing house for the macabre, the
          mysterious, and the unknown. We elevate horror games from the darkness
          into the spotlight.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-114">
          <Button size="lg" variant="primary" data-id="element-115">
            Explore Our Titles
          </Button>
          <Button size="lg" variant="secondary" data-id="element-116">
            For Developers
          </Button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-gray-500 animate-bounce" data-id="element-117">
        <ChevronDown className="w-6 h-6" data-id="element-118" />
      </motion.div>
    </section>;
}